var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPdfIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  d: "M5.625 15v-2.5m0 0V9.375H8.75V12.5zM18.75 9.375h-3.125V12.5m0 0V15m0-2.5h3.125m-8.125 1.875h3.125v-5h-3.125m0 5.625V8.75m3.75 8.125v1.25H3.125V1.875h7.5m0 0v3.75h3.75m-3.75-3.75h.625L14.375 5v.625m0 0V7.5"
})));
export default SvgPdfIcon;